"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Algorithm is public release see SARS_PAYE_BRS - PAYE Employer Reconciliation_V20 0 2 at https://www.sars.gov.za/latest-news/updated-brs-paye-employer-reconciliation/
var TINValidation = function TINValidation(tin) {
  var reIsValidLength = /^[01239]{1}\d{9}$/;

  if (reIsValidLength.test(tin)) {
    var sum = tin.split("").reduce(function (acc, curr, index) {
      if (index % 2 === 0) {
        var double = parseInt(curr) * 2;
        return acc + Math.floor(double / 10) + double % 10;
      } else {
        return acc + parseInt(curr);
      }
    }, 0);
    return sum % 10 === 0;
  }

  return false;
};

var _default = TINValidation;
exports.default = _default;